module.exports = __webpack_public_path__ + "static/img/icon_search.f2baabc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common-icons/icon_search.svg
// module id = 3E5l
// module chunks = 1